import { IIndexable } from '@utils/TypeHelpers';
import React from 'react';

export function useUtils () {
    const transformObject = React.useCallback(function <TSource, TTarget>(source: TSource, targetKeys: Array<keyof TSource>) {
        var keys = Object.keys(source);
        var l = keys.length;
        const target: IIndexable = {};
        for (let i = 0; i < l; i++) {
            const key = keys[i];
            const keyOf = key as keyof TSource;

            if (targetKeys.indexOf(keyOf) !== -1) {
                target[key] = source[keyOf];
            }
        }

        return target as TTarget;
    }, []);

    return React.useMemo(() => ({
        transformObject
    }), [transformObject])
}